import { HeaderCell } from ".";
import { HeaderCellMenuItem } from "./HeaderCellMenuItem";
import { useAtom } from "jotai";
import { showReadableLabelAtom } from "../../../Labeling.state";

export function LabelHeaderCell(props) {
    const [showReadableLabel, setShowReadableLabel] = useAtom(
        showReadableLabelAtom,
    );

    return (
        <HeaderCell {...props}>
            <HeaderCellMenuItem
                onClick={() => setShowReadableLabel(!showReadableLabel)}
                label={
                    showReadableLabel
                        ? "Show readable labels"
                        : "Show system labels"
                }
            />
        </HeaderCell>
    );
}
